import I18N from '@leverege/i18n';
import { ModelFactory } from '@leverege/ui-plugin';
// import { UserSettings } from '@leverege/ui-redux'

const {
  t
} = I18N.ns('molten.dataViewers.table.SetEditableAction');
export default {
  id: 'molten.dataViewers.table.SetEditableAction',
  matches: {
    use: 'actionBar',
    client: ['TableDataViewer', 'molten.dataViewer.details.DetailsItemInfoDataViewer']
  },
  handles: context => {
    const {
      clientProps
    } = context;
    const {
      settings
    } = clientProps;
    const Model = ModelFactory.get(settings);
    let editable = true;
    if (Model?.getEditable) {
      editable = Model.getEditable(settings);
    }
    return editable;
  },
  layout: {
    // group : [ 'Settings' ],
    // groupIcons : [ t( 'configIcon', 'fa fa-cog fa-fw' ) ],
  },
  sort: 'edit.on',
  appearance: ({
    context
  }) => {
    const {
      clientProps
    } = context;
    const {
      overrideModel
    } = clientProps;
    const curr = overrideModel?.editable;
    return {
      name: t('editable'),
      icon: 'fa fa-pencil fa-fw',
      checkStyle: 'toggle',
      checked: curr === true
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps
    } = context;
    const {
      /* settingsData, onSettingsChange, */overrideModel,
      overrides,
      dataViewerId
    } = clientProps;

    // To change the settings
    // const nModel = { ...settings, editable : !settings.editable }
    // onSettingsChange( { value : nModel, data : settingsData } )

    // To change the override
    const curr = overrideModel && overrideModel.editable != null ? overrideModel.editable : null;
    if (curr == null || curr === overrideModel.editable) {
      overrides.set(dataViewerId, 'editable', !overrideModel?.editable);
    } else {
      overrides.set(dataViewerId, 'editable', null); // go back to default
    }
  }
};